module.exports = __webpack_public_path__ + "img/background.4760670.jpeg";